export default __webpack_public_path__ + "static/media/vegan-products-in-coffee-shops-square.141f37ba.png";